import * as React from "react";
import { Img } from "../../../Img";
export const CardWithIcon = (props) => (React.createElement("div", { className: "card-with-icon" },
    React.createElement("div", { className: "card-with-icon__img-container" },
        React.createElement(Img, { src: props.imageUrl, alt: props.imageAlt })),
    React.createElement("div", { className: "card-with-icon__text-container" },
        React.createElement("h2", { className: "card-with-icon__title" }, props.title),
        React.createElement("p", null, props.text))));
